import styled from 'styled-components';
import { Col as ColAntd, Row as RowAntd, Image} from 'antd';


export const Col = styled(ColAntd)`

    
`


export const Img = styled(Image)`
    width: 13vh;
    height: 13vh;
    margin: 0;
    position: inherit;
    top: 13vh;

    @media screen and (max-width: 1500px) {
        width: 18vh;
        height: 18vh;
        top: 10vh;
    }

    @media screen and (max-width: 768px) {
        width: 10vh;
        height: 10vh;
        top: 13vh;
    }
`    

export const Div = styled.div`
    text-align: center;
    height: 40vh;
`

export const Text = styled.p`
    top: 12vh;
    margin: 0;
    position: relative;

    @media screen and (max-width: 1500px) {
        top: 9vh;
    }

    @media screen and (max-width: 768px) {
        top: 13vh;
    }
`


